import { options } from './search'
import { CarouselManager } from "../utils/carouselManager";
import { query } from "@splidejs/splide/src/js/utils";
import { getVisitorId } from './g-utils';

document.addEventListener("search:pageFilterPriceClear", (e) => {
  pageFilterPriceClear(e);
});


// receive CATEGORY facet on search page
export function getcategoryFilter() {
  let categoryFilter;

  if (sessionStorage.getItem("categoryFilter")) {
    categoryFilter = JSON.parse(sessionStorage.getItem("categoryFilter"));
  }

  return categoryFilter;
}

// receive SERIES facet on opus page
export function getSeriesFilterString() {
  let seriesFilterString;

  if (sessionStorage.getItem("seriesFilterString")) {
    seriesFilterString = JSON.parse(
      sessionStorage.getItem("seriesFilterString")
    );
  }

  return seriesFilterString;
}

// return all filters that should be applyed on search page
export function getFilterParse(
  query,
  categoryFilter,
  seriesFilterString,
  paramsQuery
) {
  let queryString = "";
  if (paramsQuery) {
    queryString = paramsQuery.q;
  }
  let filterParse;

  if (sessionStorage.getItem("defaultFilters")) {
    filterParse = JSON.parse(sessionStorage.getItem("defaultFilters"));
    if (filterParse.queryString.length > 0) {
      if (categoryFilter) {
        filterParse.queryString.push(categoryFilter.categoryFilterString);
      }
      if (seriesFilterString) {
        filterParse.queryString.push(seriesFilterString.queryString);
      }
      if (queryString.includes("opusID")) {
        filterParse.queryString.push(
          `attributes.opus: ANY("${queryString.split(":")[1]}")`
        );
      }
      query.filterSearch = filterParse.queryString.join(" AND ");
    }
  } else {
    filterParse = { filterCheckedItems: [], queryString: [], filterPrice: {} };
    if (categoryFilter) {
      filterParse.queryString.push(categoryFilter.categoryFilterString);
    }
    if (seriesFilterString) {
      filterParse.queryString.push(seriesFilterString.queryString);
    }
    if (queryString.includes("opusID")) {
      filterParse.queryString.push(
        `attributes.opus: ANY("${queryString.split(":")[1]}")`
      );
    }
    query.filterSearch = filterParse.queryString.join(" AND ");
  }

  return filterParse;
}

document.addEventListener("search:resetsessionStorageVariablesFilters", (e) => {
  sessionStorage.setItem("defaultFilters", "");
  sessionStorage.setItem("productsPerPage", "");
  sessionStorage.setItem("currentPage", "");
  sessionStorage.setItem("sortPageMode", "");
  sessionStorage.setItem("categoryFilter", "");
  sessionStorage.setItem("seriesFilterString", "");
});

if (!sessionStorage.getItem('enterTime')) {
  sessionStorage.setItem('enterTime', new Date())
}

const enterTime = sessionStorage.getItem('enterTime')

document.addEventListener('click', async (e) => {
  const clickedEl = e.target.closest('.js-facet-redirect')
  if (clickedEl) {
    e.preventDefault()
    const redirectKey = clickedEl.dataset.facetKey
    const redirectValue = clickedEl.dataset.facetValue
    let nextURL = window.location.origin
    if (redirectKey == 'author') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'click_autocomplete_ta',
        search_query: redirectValue,
        autocomplete_type: redirectKey
      });
    }
    if (redirectKey == 'opus') {
      const redirectOpus = clickedEl.dataset.facetOpus
      nextURL = nextURL + `/products/${redirectOpus}`
    
    } else {
      nextURL = nextURL + `/search?q=${encodeURIComponent(redirectValue)}`
    }
    sessionStorage.setItem('redirectKey', redirectKey)
    window.location.href = nextURL;
  }
})

const container = document.querySelector('[data-filters]'); // Container where the element will be added
const getUniqueValues = arr => [...new Set(arr)];

export const facetToRender = [
  {
    facet_title: "Categories",
    facet_key: "categories",
    show_search: true,
    autocomplete_key: 'category'
  },
  {
    facet_title: "Prix",
    facet_key: "price",
    show_search: false,
    autocomplete_key: ''
  },
  {
    facet_title: "Auteur",
    facet_key: "brands",
    show_search: true,
    autocomplete_key: 'author'
  },
  {
    facet_title: "Format",
    facet_key: "attributes.format",
    show_search: false,
    autocomplete_key: ''
  },
  {
    facet_title: "Éditeur",
    facet_key: "attributes.publisher",
    show_search: true,
    autocomplete_key: 'publisher'
  },
  {
    facet_title: "Date de parution",
    facet_key: "attributes.publicationDate",
    show_search: false,
    autocomplete_key: '',
  },
  {
    facet_title: "Langue",
    facet_key: "attributes.language",
    show_search: true,
    autocomplete_key: ''
  },
  {
    facet_title: "Produits en stock uniquement",
    facet_key: "availability",
    show_search: false,
    autocomplete_key: ''
  }
];

export const languageAssosiation =
{
  "ar": "Arabic",
  "ca-ES": "Catalan",
  "da-DK": "Danish",
  "de-DE": "Allemand",
  "en-US": "Anglais",
  "es-ES": "Espagnol",
  "fr-FR": "Français",
  "hr-HR": "Croate",
  "it-IT": "Italienne",
  "ja-JP": "Japonais",
  "ko-KR": "Coréen",
  "nl-NL": "Néerlandais",
  "pl-PL": "Polonaise",
  "pt-BR": "Portuguese",
  "ro-RO": "Romanian",
  "ru-RU": "Russian",
  "sv-SE": "Swedish",
  "zh-CN": "Chinese",
  "tr-TR": "Turc"
}

export const dateAssosiation =
{
  'Moins de 2 ans': Math.round(new Date(new Date(enterTime).setFullYear(new Date(enterTime).getFullYear() - 2)).getTime() / 1000) + '-M',
  'Moins de 5 ans': Math.round(new Date(new Date(enterTime).setFullYear(new Date(enterTime).getFullYear() - 5)).getTime() / 1000) + '-M',
  'Moins de 10 ans': Math.round(new Date(new Date(enterTime).setFullYear(new Date(enterTime).getFullYear() - 10)).getTime() / 1000) + '-M',
  'Plus de 10 ans': Math.round(new Date(new Date(enterTime).setFullYear(new Date(enterTime).getFullYear() - 10)).getTime() / 1000) + '-P'
}

export const availabilityAssosiation =
{
  "IN_STOCK": "En stock",
}

export async function updateFilters(url, filterParse, query, data) {

  if (data.results) {
    updateRenderedFilters(data, filterParse)
  }
}

export async function getFilters(event, url, filterParse, paramsQuery, paramsQuerySearchText, data) {
  
  if (data.results) {
    // facets
    renderFilters(data, filterParse)
    renderOpusHeader(paramsQuery, event, data)
  }
 
}

function renderFilters(data, filterParse) {
  const filterActivePriceMin = filterParse?.filterPrice?.min;
  const filterActivePriceMax = filterParse?.filterPrice?.max;
  const activeFiltersItems = filterParse?.filterCheckedItems ?? [];
  const filterPriceMax = data.facets.find((facet) => facet.key == "price").values[0].maxValue;

  // do not disable filters on currently clicked filters block
  let clickedFilter = window.lastCheckedFilter || "";
  if (clickedFilter != "") {// potential remove
    clickedFilter = clickedFilter.closest("filter-block").id;
    let numberOfSelectedFilters = document.getElementById(clickedFilter).querySelectorAll("filter-item [name^='filter.p']:checked")
    // console.log(numberOfSelectedFilters.length);
    if (numberOfSelectedFilters.length == 0) {
      clickedFilter = "";
    }
  }
  if (document.querySelectorAll("filter-block").length > 1) { // potential remove
    document.querySelectorAll("filter-block").forEach((filterBlock) => {
      for (const facet in facetToRender) {
        if (
          facetToRender[facet].facet_key != "price" &&
          facetToRender[facet].facet_key != "categories" &&
          facetToRender[facet].facet_key != "attributes.publicationDate" &&
          facetToRender[facet].facet_key != "availability" &&
          facetToRender[facet].facet_key != clickedFilter
        ) {
          if (facetToRender[facet].facet_key == filterBlock.id) {
            filterBlock.setChildItemFilter = {
              data: data.facets.find((initial_facet) => initial_facet.key == facetToRender[facet].facet_key).values || [],
              type: facetToRender[facet].facet_key,
              checkedItems: activeFiltersItems
            };
          }
        }
      }
    })
  }
  else {
    for (const facet in facetToRender) {
      if (facetToRender[facet].facet_key == "availability") {
        continue
      }
      // Create a new instance of ProductItem
      const filterBlock = document.createElement('filter-block');
      filterBlock.setParentBlockFilterText = {
        title: facetToRender[facet].facet_title,
        type: facetToRender[facet].facet_key,
        showSearch: facetToRender[facet].show_search
      };
      // render all filters except price/categories/publicationDate
      if (facetToRender[facet].facet_key != "price" &&
        facetToRender[facet].facet_key != "categories" &&
        facetToRender[facet].facet_key != "availability" &&
        facetToRender[facet].facet_key != "attributes.publicationDate") {
        // Set the product data
        filterBlock.setChildItemFilter = {
          data: data.facets.find((initial_facet) => initial_facet.key == facetToRender[facet].facet_key).values || [],
          type: facetToRender[facet].facet_key,
          checkedItems: activeFiltersItems
        };
      }
      //render categories
      if (facetToRender[facet].facet_key == "categories") {
        filterBlock.setChildItemCategory = {
          title: facetToRender[facet].facet_title,
          type: facetToRender[facet].facet_key,
          data: data.facets.find((initial_facet) => initial_facet.key == facetToRender[facet].facet_key).values || [],
        }
      }
      //render price
      if (facetToRender[facet].facet_key == "price") {
        filterBlock.setChildItemPrice = {
          title: facetToRender[facet].facet_title,
          type: facetToRender[facet].facet_key,
          data: data.facets.find((initial_facet) => initial_facet.key == facetToRender[facet].facet_key).values || [],
          priceMax: Math.ceil(filterPriceMax),
          priceActiveMin: filterActivePriceMin,
          priceActiveMax: filterActivePriceMax
        }
      }
      //render publicationDate
      if (facetToRender[facet].facet_key == "attributes.publicationDate") {
        filterBlock.setChildItemDate = {
          title: facetToRender[facet].facet_title,
          type: facetToRender[facet].facet_key,
          data: dateAssosiation || [],
          checkedItems: activeFiltersItems
        }
      }

      filterBlock.setAttribute("id", facetToRender[facet].facet_key)

      // Append the new product item to the container
      container.appendChild(filterBlock);
    }
  }
}

function updateRenderedFilters(data, filterParse) {
  let notInListFilters = filterParse?.filterCheckedItems || []

  notInListFilters.map((unlistedFilter) => {
    const filterToCheck = document.querySelector(`input[id="${unlistedFilter}"]`)
    if (!filterToCheck) {
      let filterValue = unlistedFilter.split("-")[1]
      let filterType = unlistedFilter.split("-")[0].split("filter.p.")[1]
      const filterItem = document.createElement('filter-item');
      filterItem.className = "collection__filter-checkbox"

      // Set the product data
      filterItem.filters = {
        checked: true,
        type: filterType,
        value: filterValue
      };
      document.querySelector(`filter-block[id='${filterType}'] .collection__filter-checkbox-list`).appendChild(filterItem)
    }
  })
  const activeFiltersItems = filterParse?.filterCheckedItems ?? [];

  let clickedFilter = window.lastCheckedFilter || "";
  if (clickedFilter != "") {
    clickedFilter = clickedFilter.closest("filter-block").id;
    let numberOfSelectedFilters = document.getElementById(clickedFilter).querySelectorAll("filter-item [name^='filter.p']:checked")
    // console.log(numberOfSelectedFilters.length);
    if (numberOfSelectedFilters.length == 0) {
      clickedFilter = "";
    }
  }
  if (document.querySelector("filter-block")) {
    document.querySelectorAll("filter-block").forEach((filterBlock) => {
      for (const facet in facetToRender) {
        if (facetToRender[facet].facet_key != "price" && facetToRender[facet].facet_key != "attributes.publicationDate" && facetToRender[facet].facet_key != "availability" && facetToRender[facet].facet_key != clickedFilter) {
          if (facetToRender[facet].facet_key == filterBlock.id) {
            filterBlock.updateChildItemFilter = {
              data: data.facets.find((initial_facet) => initial_facet.key == facetToRender[facet].facet_key)?.values || [],
              type: facetToRender[facet].facet_key,
              checkedItems: activeFiltersItems
            };
          }
        }
      }
    })
  }
}

async function renderOpusHeader(paramsQuery, event, data) {
  const productsResults = data.results;
  let searchProductVariants = [];
  productsResults.forEach((searchProduct) => {
    searchProductVariants.push(searchProduct.product);
  });
  const authorsFiler = data.facets.find((facet) => facet.key == "brands").values || [];
  const faceSaga = data.facets.find((facet) => facet.key == "attributes.series");
  if (
    paramsQuery.q.includes("opusID")
  ) {
    const facetSagaName = faceSaga.values ? faceSaga.values[0].value : '';
    const templateBlockOpusHeader = document.getElementById("opus_header_template")
    const opusHeaderTemplate = templateBlockOpusHeader
      .innerHTML.replaceAll("[title]", searchProductVariants[0].title)
      .replaceAll("[author]", authorsFiler[0].value)
      .replaceAll("[sagaName]", facetSagaName ?? "");
    document.title = document.title.split(" - ").map(el => {
      if (el.indexOf("opusID:") > -1) {
        return searchProductVariants[0].title
      }
      else {
        return el
      }
    }).join(" - ")

    event.element.querySelector("[data-opus-header]").innerHTML = opusHeaderTemplate;
    if (event.element.querySelector("[data-breadcrumb-opus]")) {
      event.element.querySelector("[data-breadcrumb-opus]").innerHTML = event.element.querySelector("[data-breadcrumb-opus]").innerHTML = `"${searchProductVariants[0].title}"`;
    }
    document.querySelector(".jc-search-header").classList.add("jc-hidden");
    document.querySelector(".jc-opus-header").classList.remove("jc-hidden");
    if (!faceSaga.values) {
      event.element.querySelector("opus-series").closest('.splide__slide').classList.add('!jc-hidden')
    }
    if (!authorsFiler.values) {
      event.element.querySelector("opus-author").closest('.splide__slide').classList.add('!jc-hidden')
    }
    const opusInfosSliderEl = document.querySelector("#opus-infos-slider");
    await CarouselManager.create(opusInfosSliderEl, {
      arrows: false,
      pagination: false,
      perPage: 2,
      gap: 8,
      breakpoints: {
        640: {
          perPage: 1.15,
          destroy: true
        }
      }
    });
  }
}

class FilterBlock extends HTMLElement {
  constructor() {
    super();
  }

  // Use properties to dynamically update the content
  set setParentBlockFilterText(filterData) {
    this.innerHTML = document.getElementById('filter-collapsible-block').innerHTML;
    this.classList.add('[&_.collection-filter-group]:last:!jc-pb-0')
    this.querySelector('.filter-collapsible-block-title').textContent = filterData.title;
    this.querySelector('input').placeholder = filterData.title;
    this.querySelector('.collection__filter-group-name').setAttribute("aria-controls", `filter-p-${filterData.type.replaceAll(".", "_")}`);
    this.querySelector('.collection__filter-collapsible').id = `filter-p-${filterData.type.replaceAll(".", "_")}`;
    if (filterData.showSearch == false) {
      this.querySelector('search-filter-block').remove()
    }
    if (filterData.type == 'availability') {
      this.querySelector('button').classList.add('jc-hidden')
    }
  }

  set setChildItemFilter(filterData) {
    const checkedFilters = filterData.checkedItems.map(checkedItem => checkedItem.split(/-(.*)/s)[1])

    // this.querySelector('.collection__filter-checkbox-list').innerHTML = ""
    filterData.data.map((facet) => {
      let existedFilter = "";

      // Escape special characters in facet.value
      const escapedValue = facet.value.replace(/([\'\"\\.])/g, "\\$1");

      // Query the selector with escaped value
      existedFilter = this.querySelector(`[id='filter\\.p\\.${filterData.type}-${escapedValue}']`);

      if (!existedFilter) {
        const filterItem = document.createElement('filter-item');
        filterItem.className = "collection__filter-checkbox";

        // Set the product data
        filterItem.filters = {
          checked: checkedFilters.includes(facet.value),
          type: filterData.type,
          value: facet.value
        };
        this.querySelector('.collection__filter-checkbox-list').appendChild(filterItem);
      }
    });
  }

  set setChildItemFilterAvailability(filterData) {
    const checkedFilters = filterData.checkedItems.map(checkedItem => checkedItem.split(/-(.*)/s)[1])

    // this.querySelector('.collection__filter-checkbox-list').innerHTML = ""
    filterData.data.map((facet) => {
      const filterItem = document.createElement('filter-item');
      filterItem.className = "collection__filter-checkbox"

      // Set the product data
      filterItem.filters = {
        checked: checkedFilters.includes(facet.value),
        type: filterData.type,
        value: facet.value,
        title: filterData.title
      };
      this.querySelector('.collection__filter-checkbox-list').appendChild(filterItem)
    })
  }

  set updateChildItemFilter(filterData) {
    // console.log("data on update", filterData);
    const checkedFilters = document.querySelectorAll("filter-item [name^='filter.p']:checked");
    const checkedFiltersBlocks = Array.from(checkedFilters).map((el) => el.closest("filter-block").id)
    const numberOfBlockWithCheckedFilters = getUniqueValues(checkedFiltersBlocks)

    if (sessionStorage.getItem('categoryFilter') != '') {
      numberOfBlockWithCheckedFilters.push('categories')
    }
    else {
      numberOfBlockWithCheckedFilters.filter(id => id != 'categories')
    }

    // console.log(numberOfBlockWithCheckedFilters);

    if (this.id == filterData.type) {
      if (this.id == 'categories') {
        this.querySelectorAll('[data-parent-category] > *').forEach((el) => {
          if (el.closest("filter-block").id != 'attributes.publicationDate') {
            el.classList.add("jc-hidden", "jc-pointer-events-none")
          }
        })
      }
      else {
        this.querySelectorAll("filter-item").forEach((el) => {
          if (el.closest("filter-block").id != 'attributes.publicationDate') {
            el.classList.add("jc-hidden", "jc-pointer-events-none")
          }
        })
      }
    }
    filterData.data.map((facet) => {
      if (filterData.type == 'categories') {
        const category = facet.value.split(' > ');
        const categoryName = category[0];
        const categorySubName = category[1] || '';  // Ensure subcategory exists

        // Select parent category block
        const categoryBlock = this.querySelector(`[data-parent-category="${categoryName}"] p`);

        if (categoryBlock) {
          categoryBlock.classList.remove("jc-hidden", "jc-pointer-events-none");

          // If there's a subcategory, make sure to show it
          if (categorySubName) {
            const subCategoryBlock = categoryBlock.closest('[data-parent-category]')
              .querySelector(`[data-sub-category="${categorySubName}"]`);
            if (subCategoryBlock) {
              subCategoryBlock.classList.remove("jc-hidden", "jc-pointer-events-none");
            }
          }
        }
      } else {
        // Handle filters with special characters uniformly
        const escapedValue = facet.value.replace(/([\'\"\\.])/g, "\\$1");
        const existedFilter = this.querySelector(`[id='filter\\.p\\.${filterData.type}-${escapedValue}']`);

        if (existedFilter) {
          existedFilter.closest("filter-item").classList.remove("jc-hidden", "jc-pointer-events-none");
        }
      }
    });


    if (numberOfBlockWithCheckedFilters.length == 1 && numberOfBlockWithCheckedFilters[0] == this.id) {
      // console.log(this.id)

      this.querySelectorAll(".jc-hidden.jc-pointer-events-none").forEach((el) => {
        if (this.id != 'attributes.publicationDate') {
          el.classList.remove("jc-hidden", "jc-pointer-events-none")
        }
      })
    }

  }

  set setChildItemPrice(priceData) {
    this.querySelector('.collection__filter-checkbox-list').innerHTML = ""
    const filterItem = document.createElement('filter-price-item');
    filterItem.filters = priceData

    this.querySelector('.collection__filter-checkbox-list').appendChild(filterItem)
  }

  set setChildItemCategory(categoryData) {
    this.querySelector('.collection__filter-checkbox-list').innerHTML = ""
    const filterItem = document.createElement('filter-category-item');
    filterItem.filters = categoryData

    this.querySelector('.collection__filter-checkbox-list').appendChild(filterItem)
  }

  set setChildItemDate(dateData) {
    const checkedFilters = dateData.checkedItems.map(checkedItem => checkedItem.split(/-(.*)/s)[1])

    for (const [facet, value] of Object.entries(dateData.data)) {
      const filterItem = document.createElement('filter-item');
      filterItem.className = "collection__filter-checkbox"

      // Set the product data
      filterItem.filters = {
        checked: checkedFilters.includes(dateAssosiation[facet]),
        type: dateData.type,
        value: dateAssosiation[facet],
        facetValue: facet
      };
      this.querySelector('.collection__filter-checkbox-list').appendChild(filterItem)

      if (dateData.data[Object.keys(dateData.data)[Object.keys(dateData.data).length - 1]] == value) {
        filterItem.updatePublicationDate()
      }
    }
  }
}

class FilterItem extends HTMLElement {
  constructor() {
    super();
  }

  updatePublicationDate() {
    this.closest('filter-block').querySelectorAll('filter-item').forEach(el => {
      el.classList.remove("jc-hidden", "jc-pointer-events-none")
    })

    const activeFilterDate = this.closest('filter-block').querySelector('input:checked')

    if (activeFilterDate) {
      const uncheckedDate = this.closest('filter-block').querySelectorAll(`label:not([for*="${activeFilterDate.id.split('-').pop()}"])`);

      uncheckedDate.forEach(date => {
        date.closest('filter-item').classList.add("jc-hidden", "jc-pointer-events-none")
      })
    }
  }

  // Use properties to dynamically update the content
  set filters(filterData) {
    const filterType = filterData.type;
    const filterValue = filterData.value;
    if (filterType == 'attributes.publicationDate') {
      this.addEventListener('click', this.updatePublicationDate)
    }
    if (filterType == 'availability') {
      this.innerHTML = document.getElementById('filter-collapsible-block-item-availability').innerHTML;
      this.querySelector('label').click()
    }
    else {
      this.innerHTML = document.getElementById('filter-collapsible-block-item').innerHTML;
    }
    if (filterType == 'availability') {
      this.querySelector('p').textContent = filterData.title;
    }
    else {
      this.querySelector('label').textContent = (() => {
        switch (filterData.type) {
          case "attributes.language": return languageAssosiation[filterValue];
          case "availability": return availabilityAssosiation[filterValue];
          case "attributes.publicationDate": return filterData.facetValue;
          default: return filterValue;
        }
      })();
    }
    this.querySelector('input').value = filterValue;
    this.querySelector('input').id = `filter.p.${filterType}-${filterValue}`;
    this.querySelector('input').setAttribute("name", `filter.p.${filterType}`);
    if (filterData.checked) {
      this.querySelector('input').checked = true;
    }
    this.querySelector('label').setAttribute("for", `filter.p.${filterType}-${filterValue}`);
  }

}


class FilterPriceItem extends HTMLElement {
  constructor() {
    super();
  }

  // Use properties to dynamically update the content
  set filters(priceData) {
    this.innerHTML = document.getElementById('filter-collapsible-price-block-item').innerHTML;
    let maxValue = priceData.priceMax
    let currentMinValue = priceData.priceActiveMin
    let currentMaxValue = priceData.priceActiveMax
    let range_min = currentMinValue ? (currentMinValue / maxValue) * 100 + " %" : (0 / maxValue) * 100 + "%";
    let range_max = currentMaxValue ? (currentMaxValue / maxValue) * 100 + "%" : (maxValue / maxValue) * 100 + "%";
    let range_min_val = currentMinValue ? currentMinValue : "0";
    let range_max_val = currentMaxValue ? currentMaxValue : maxValue;
    let currentMin = currentMinValue ? currentMinValue : ""
    let currentMax = currentMaxValue ? currentMaxValue : ""
    this.querySelector('.price-range__range-group').setAttribute("style", `--range-min:${range_min};--range-max:${range_max}`);
    this.querySelector('.range-min').setAttribute("max", maxValue);
    this.querySelector('.range-min').setAttribute("value", range_min_val);
    this.querySelector('.range-max').setAttribute("max", maxValue);
    this.querySelector('.range-max').setAttribute("value", range_max_val);
    this.querySelector('[name=filter\\.v\\.price\\.gte]').setAttribute("max", maxValue);
    if (currentMin) {
      this.querySelector('[name=filter\\.v\\.price\\.gte]').setAttribute("value", currentMin);
    }
    else {
      this.querySelector('[name=filter\\.v\\.price\\.gte]').setAttribute("value", 0);
    }
    this.querySelector('[name=filter\\.v\\.price\\.lte]').setAttribute("max", maxValue);
    if (currentMax) {
      this.querySelector('[name=filter\\.v\\.price\\.lte]').setAttribute("value", currentMax);
    }
    else {
      this.querySelector('[name=filter\\.v\\.price\\.lte]').setAttribute("value", maxValue);
    }
  }

}

class FilterCategoryItem extends HTMLElement {
  constructor() {
    super();
  }

  // Use properties to dynamically update the content
  set filters(categoryData) {
    // console.log("categoryData", categoryData);
    const arrayFilteredCategories = this.parseCategoryData(categoryData);

    // console.log(arrayFilteredCategories);
    arrayFilteredCategories.forEach((category) => {
      let parentCategoryBlock = document.querySelector(`[data-parent-category='${category.categoryName}']`);
      let categoryBlock = "";
      if (!parentCategoryBlock) {
        categoryBlock = document.createElement("ul");
        categoryBlock.className = "jc-list-none";
        categoryBlock.setAttribute("data-parent-category", category.categoryName);
        const categoryBlockTitle = document.createElement("p");
        categoryBlockTitle.className = "jc-m-0 jc-py-1.5 jc-text-sm jc-leading-5 jc-font-semibold jc-cursor-pointer jc-text-richBlack"
        categoryBlockTitle.textContent = category.categoryName;
        categoryBlock.appendChild(categoryBlockTitle);
      }
      else {
        categoryBlock = parentCategoryBlock
      }

      if (category.subCategoryArray) {
        category.subCategoryArray.filter(el => el).forEach((subcategory) => {
          let subcategoryBlock = "";
          if (subcategory.subCategoryName.indexOf("\"") > -1) {
            subcategoryBlock = categoryBlock.querySelector(`[data-sub-category='${subcategory.subCategoryName}']`)
          }
          else if (subcategory.subCategoryName.indexOf("\'") > -1) {
            subcategoryBlock = categoryBlock.querySelector(`[data-sub-category="${subcategory.subCategoryName}"]`)
          }
          else {
            subcategoryBlock = categoryBlock.querySelector(`[data-sub-category="${subcategory.subCategoryName}"]`)
          }

          if (!subcategoryBlock) {
            const subCategoryBlock = document.createElement("li")
            subCategoryBlock.setAttribute("data-sub-category", subcategory.subCategoryName);
            subCategoryBlock.className = "jc-px-3 jc-py-1.5 jc-text-sm jc-leading-5 jc-cursor-pointer js-filter-category" +
              " jc-transition-colors jc-duration-300 hover:jc-text-independence focus:jc-text-electricViolet active:jc-text-electricViolet";
            subCategoryBlock.textContent = subcategory.subCategoryName
            categoryBlock.appendChild(subCategoryBlock);
          }
        })
      }

      categoryBlock.addEventListener("click", (e) => {
        if (e.target.tagName == 'LI' || e.target.tagName == 'P') {
          const categoryFilter = {
            categoryFilterString: '',
            categoryFilterActive: []
          }
          if (e.target.tagName == 'LI') {
            const categoryName = e.target.parentNode.dataset.parentCategory;
            const categorySubName = e.target.dataset.subCategory;
            categoryFilter.categoryFilterString = `categories: ANY("${categoryName} > ${categorySubName}")`;
            categoryFilter.categoryFilterActive.push(`${categoryName} > ${categorySubName}`)
          }
          else if (e.target.tagName == 'P') {
            const categoryName = e.target.parentNode.dataset.parentCategory
            const categorySubNames = Array.from(e.target.parentNode.querySelectorAll('li'));
            if (categorySubNames.length > 0) {
              const categoriesFilterString = categorySubNames.map((categorySub) => {
                return `"${categoryName} > ${categorySub.dataset.subCategory}"`
              })
                .join(',')
              categoryFilter.categoryFilterString = `categories: ANY(${categoriesFilterString})`
              categoryFilter.categoryFilterActive.push(categoryName)
            }
            else {
              categoryFilter.categoryFilterString = `categories: ANY("${categoryName}")`
              categoryFilter.categoryFilterActive.push(categoryName)
            }
          }

          sessionStorage.setItem('categoryFilter', JSON.stringify(categoryFilter))
        }
      })

      if (!parentCategoryBlock) {
        this.appendChild(categoryBlock);
      }
    })
  }

  parseCategoryData(categoryData) {
    const arrayFilteredCategories = [];
    categoryData.data.forEach((category, index) => {
      if (category.value.indexOf('>') == -1) {
        arrayFilteredCategories.push({ categoryName: category.value });
        return
      }
      if (category.value.split(">")[0] == categoryData.data[index + 1]?.value.split(">")[0]) {
        return;
      }
      const filteredCategories = categoryData.data.filter(
        (el) => el.value.split(">")[0] == category.value.split(">")[0]
      );
      const categoryName = filteredCategories[0].value.split(">")[0].trim();

      const subCategoryArray = filteredCategories.map((el) => {
        if (el.value.split(">").length > 2) {
          return
        }
        if (!el.value.split(">")[1]) {
          return;
        }

        return {
          subCategoryName: el.value.split(">")[1].trim()
        };
      });
      arrayFilteredCategories.push({
        categoryName,
        subCategoryArray
      });
    });
    return arrayFilteredCategories
  }
}


// Create a class for the element
class SearchInFilterBlock extends HTMLElement {
  static observedAttributes = ["color", "size"];

  constructor() {
    // Always call super first in constructor
    super();
  }

  connectedCallback() {
    this.input = this.querySelector("input");
    this.clearText = this.querySelector('.jc-clear-text-icon')
    this.clearText.addEventListener('click', () => {
      this.input.value = ''
      this.input.dispatchEvent(new Event('input'))
    })
    this.input.addEventListener("input", () => {
      if (this.input.value.trim()) {
        this.classList.add('jc-clear-text')
      }
      else {
        this.classList.remove('jc-clear-text')
      }

      this.filter = this.input.value.toUpperCase();
      this.list = "";
      if (!this.closest("filter-block").querySelector("filter-category-item")) {
        this.list = this.closest("filter-block").querySelectorAll("filter-item");
      }
      else {
        this.list = this.closest("filter-block").querySelectorAll(".js-filter-category");
      }
      this.list.forEach((li) => {
        let a = li.getElementsByTagName("label")[0] || li;
        let txtValue = a.textContent || a.innerText;

        if (txtValue.toUpperCase().indexOf(this.filter) > -1) {
          li.classList.remove("jc-hidden");
        } else {
          li.classList.add("jc-hidden");
        }
      })

      const resultSearchEmpty = Array.from(this.list).every((li) => li.classList.contains("jc-hidden"))

      this.closest("filter-block").querySelectorAll("[data-parent-category]").forEach((el) => {
        if (el.querySelectorAll("li").length == el.querySelectorAll("li.jc-hidden").length) {
          el.classList.add("jc-hidden")
        }
        else {
          el.classList.remove("jc-hidden")
        }
      })

      if (resultSearchEmpty) {
        this.updateEmptyFilterInfo.bind(this)();
      }
    });
  }

  async updateEmptyFilterInfo() {
    const url = window.Shopify.routes.root + "apps/search";
    let filterQuery = this.input.value
    let searchStringUpperCase = this.input.value.toUpperCase()

    if (this.closest('filter-block').id === 'attributes.language') {
      for (const [key, value] of Object.entries(languageAssosiation)) {
        if (value.toUpperCase().indexOf(searchStringUpperCase) > -1) {
          filterQuery = key
          searchStringUpperCase = key.toUpperCase()
        }
      }
    }

    const query = {
      query: filterQuery,
      rout: "search",
      visitorId: getVisitorId(),
      branchSearch: "0",
      userId: window.userId
    };

    const seriesFilterString = getSeriesFilterString();
    const categoryFilter = getcategoryFilter();
    const filterParse = getFilterParse(
      query,
      categoryFilter,
      seriesFilterString
    );
    // console.log(filterParse);

    query.facetKeysSearch = [
      { facetKey: { key: facetToRender.find(facet => this.closest('filter-block').id === facet.facet_key).facet_key, returnMinMax: true }, limit: 300 }
    ];

    options.body = JSON.stringify(query);

    try {
      const response = await fetch(url, options);
      let data = response;
      if (data.ok) {
        data = await data.json()
      }
      else {
        data = await data.text()
      }
      // console.log('empty filter info', data);
      const dataResultsProduct = data.results
      if (dataResultsProduct) {
        const mainFilters = data.facets
        const filterBlock = this.closest('filter-block')
        const filterBlockId = filterBlock.id
        const notListedFilter = mainFilters.find((filter) => filter.key === filterBlockId)
        if (filterBlockId != "categories") {
          notListedFilter.values.forEach((filter) => {
            let existedFilter = ''
            if (filter.value.indexOf("\"") > -1) {
              existedFilter = filterBlock.querySelector(`[id='filter\\.p\\.${filterBlockId}-${filter.value}']`)
            }
            else if (filter.value.indexOf("\'") > -1) {
              existedFilter = filterBlock.querySelector(`[id="filter\\.p\\.${filterBlockId}-${filter.value}"]`)
            }
            else {
              existedFilter = filterBlock.querySelector(`[id='filter\\.p\\.${filterBlockId}-${filter.value}']`)
            }
            if (filter.value.toUpperCase().indexOf(searchStringUpperCase) > -1 &&
              !existedFilter) {
              const filterItem = document.createElement('filter-item');
              filterItem.className = "collection__filter-checkbox"

              // Set the product data
              filterItem.filters = {
                checked: '',
                type: this.closest('filter-block').id,
                value: filter.value
              };
              this.closest('filter-block').querySelector('.collection__filter-checkbox-list').appendChild(filterItem)
            }
          })
        }
        else {
          const filterItem = document.querySelector('filter-category-item');
          filterItem.filters = {
            title: "Categories",
            type: "categories",
            data: notListedFilter.values,
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
}

class PriceMinimum extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.setPriceMinimum)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.setPriceMinimum)
  }

  setPriceMinimum() {
    const priceRange = this.closest("filter-price-item");
    const priceMax = +this.dataset.max
    const priceMin = 0
    const maxValuePrice = +priceRange.querySelector(".range-max").max
    const rangeMax = (priceMax / maxValuePrice) * 100 + "%"

    priceRange.querySelector(".price-range__range-group").setAttribute("style", `--range-min: 0%;--range-max:${rangeMax}`)
    priceRange.querySelector(".range-min").value = priceMin;
    priceRange.querySelector(".range-max").value = priceMax;
    priceRange.querySelector("[name='filter.v.price.gte']").value = priceMin;
    priceRange.querySelector("[name='filter.v.price.lte']").value = priceMax;

    const filterJson = sessionStorage.getItem("defaultFilters") ? JSON.parse(sessionStorage.getItem("defaultFilters")) : { filterPrice: {}, queryString: [], filterCheckedItems: [] };
    filterJson.queryString = filterJson.queryString.filter(
      (string) => string.includes("price") != true
    );
    filterJson.queryString.push(`(price: IN(${priceMin}i, ${priceMax}e))`)

    filterJson.filterPrice.min = `${priceMin}`
    filterJson.filterPrice.max = `${priceMax}`

    if (!this.previousElementSibling) {
      this.nextElementSibling.querySelector('div').classList.add('!jc-bg-gray-300', 'jc-border-gray-300')
      this.querySelector('div').classList.remove('!jc-bg-gray-300', 'jc-border-gray-300')
      this.nextElementSibling.nextElementSibling.querySelector('div').classList.add('!jc-bg-gray-300', 'jc-border-gray-300')
    }
    else if (this.previousElementSibling && this.nextElementSibling) {
      this.previousElementSibling.querySelector('div').classList.remove('!jc-bg-gray-300', 'jc-border-gray-300')
      this.querySelector('div').classList.remove('!jc-bg-gray-300', 'jc-border-gray-300')
      this.nextElementSibling.querySelector('div').classList.add('!jc-bg-gray-300', 'jc-border-gray-300')
    }
    else if (!this.nextElementSibling) {
      this.previousElementSibling.querySelector('div').classList.remove('!jc-bg-gray-300', 'jc-border-gray-300')
      this.querySelector('div').classList.remove('!jc-bg-gray-300', 'jc-border-gray-300')
      this.previousElementSibling.previousElementSibling.querySelector('div').classList.remove('!jc-bg-gray-300', 'jc-border-gray-300')
    }

    sessionStorage.setItem("defaultFilters", JSON.stringify(filterJson))
  }
}

class ActiveFilterItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.action == 'clear-filter-price') {
      this.addEventListener('click', this.removePrice)
    }
    else if (this.dataset.action == 'clear-filter-category') {
      this.addEventListener('click', this.removeCategoryFilter)
    }
    else if (this.dataset.action == 'clear-filter-series') {
      this.addEventListener('click', this.removeSeriesFilter)
    }
  }

  disconnectedCallback() {
    if (this.dataset.action == 'clear-filter-price') {
      this.removeEventListener('click', this.removePrice)
    }
    else if (this.dataset.action == 'clear-filter-category') {
      this.addEventListener('click', this.removeCategoryFilter)
    }
    else if (this.dataset.action == 'clear-filter-series') {
      this.addEventListener('click', this.removeSeriesFilter)
    }
  }

  removeSeriesFilter() {
    sessionStorage.setItem("seriesFilterString", "");
  }

  removeCategoryFilter() {
    sessionStorage.setItem("categoryFilter", "");
  }

  removePrice() {
    pageFilterPriceClear()
  }

  activeFilter(activeFilterData) {
    this.innerHTML = document.getElementById('filter-active-button').innerHTML
    this.querySelector('label').setAttribute('for', activeFilterData.activeFilter)
    this.querySelector('p').textContent = (() => {
      switch (activeFilterData.type) {
        case "price": return activeFilterData.activeFilter;
        case "filter": return languageAssosiation[activeFilterData.activeFilter.split(/-(.*)/s)[1]] ||
          availabilityAssosiation[activeFilterData.activeFilter.split(/-(.*)/s)[1]] ||
          Object.keys(dateAssosiation).find(key => dateAssosiation[key] === activeFilterData.activeFilter.split(/-(.*)/s)[1]) ||
          activeFilterData.activeFilter.split(/-(.*)/s)[1];
        case "category": return activeFilterData.activeFilter;
        case "series": return activeFilterData.activeFilter;
        default: return null;
      }
    })();
  }
}

function pageFilterPriceClear() {
  const priceRange = document.querySelector("price-range");
  priceRange.querySelector(".price-range__range-group").style.cssText = "--range-min:0%;--range-max:100%";
  priceRange.querySelector(".range-min").value = priceRange.querySelector(".range-min").min;
  priceRange.querySelector(".range-max").value = priceRange.querySelector(".range-min").max;
  priceRange.querySelector("[name='filter.v.price.gte']").value = "";
  priceRange.querySelector("[name='filter.v.price.lte']").value = "";

  const filterJson = JSON.parse(sessionStorage.getItem("defaultFilters"));
  filterJson.filterPrice = {};
  filterJson.queryString = filterJson.queryString.filter(
    (string) => string.includes("price") != true
  );
  sessionStorage.setItem("defaultFilters", JSON.stringify(filterJson));
}

customElements.define('filter-block', FilterBlock);
customElements.define('active-filter-item', ActiveFilterItem);
customElements.define('filter-item', FilterItem);
customElements.define('filter-price-item', FilterPriceItem);
customElements.define('filter-category-item', FilterCategoryItem);
customElements.define("search-filter-block", SearchInFilterBlock);
customElements.define('price-minimum', PriceMinimum);


window.addEventListener("resize", setMobileFilterClass)

window.addEventListener("DOMContentLoaded", setMobileFilterClass)

function setMobileFilterClass() {
  const mobileFilters = document.getElementById("mobile-collection-filters");
  if (!mobileFilters || mobileFilters.classList.contains("wishlist")) {
    return;
  }
}
